import React, { Component } from 'react'
import CampoNotificacionChofer from '../../components/notificaciones/CampoNotificacionChofer'
import * as actions from '../../actions'
import { connect } from 'react-redux'

class NotificacionChofer extends Component {
  constructor (props) {
    super(props)
    this.submitNotificacion = this.submitNotificacion.bind(this)
    this.deleteNotificacion = this.deleteNotificacion.bind(this)
  }

  componentDidMount () {
    this.props.getNotificacionesChofer()
  }

  async submitNotificacion (notificacion, vencimiento, prioridad) {
    this.props.submitNotificacion(notificacion, vencimiento, prioridad)
    const notificaciones = await this.props.getNotificacionesChofer()
    console.log(notificaciones)
  }

  async deleteNotificacion (fechaEmision) {
    this.props.eliminarNotificacion(fechaEmision)
    const notificaciones = await this.props.getNotificacionesChofer()
    console.log(notificaciones)
  }

  render () {
    const { notificacionesChofer } = this.props
    return (
      <div >
        <h2>Notificaciones para choferes</h2>
        <hr />
        <div className='container-notificacion-chofer'>
          <CampoNotificacionChofer
            notificacionesChofer={notificacionesChofer}
            submitNotificacion={this.submitNotificacion}
            deleteNotificacion={this.deleteNotificacion}
          />
        </div>
      </div>

    )
  }
}

const mapStateToProps = (state) => ({
  notificacionesChofer: state.camionesIngreso.notificacionesChofer,
  username: state.auth.username
})

const withRedux = connect(mapStateToProps, actions)

export default withRedux(NotificacionChofer)
